const GoldIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={24} height={24} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M18.1274 20.9025H9.77187C7.54372 20.9025 5.74154 19.0662 5.74154 16.7959H14.0971C16.3252 16.7959 18.1274 18.6322 18.1274 20.9025Z'
        fill='url(#paint0_linear_43_92411)'
      />
      <path
        d='M10.8859 3.84158C7.77305 3.84158 5.25 6.41236 5.25 9.61748C5.25 12.8226 7.77305 15.36 10.8859 15.36C13.9988 15.36 16.5218 12.7892 16.5218 9.61748C16.5218 6.44575 13.9988 3.84158 10.8859 3.84158ZM10.9187 11.5205C9.87013 11.5205 9.05096 10.6525 9.05096 9.61748C9.05096 8.54911 9.9029 7.71444 10.9187 7.71444C11.9672 7.71444 12.7864 8.58249 12.7864 9.61748C12.7864 10.6525 11.9672 11.5205 10.9187 11.5205Z'
        fill='url(#paint1_linear_43_92411)'
      />
      <path
        d='M16.8823 5.41107C17.9138 5.41107 18.75 4.55904 18.75 3.50802C18.75 2.457 17.9138 1.60498 16.8823 1.60498C15.8508 1.60498 15.0146 2.457 15.0146 3.50802C15.0146 4.55904 15.8508 5.41107 16.8823 5.41107Z'
        fill='url(#paint2_linear_43_92411)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_43_92411'
          x1='18.75'
          y1='11.2537'
          x2='5.25'
          y2='11.2537'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#806931' />
          <stop offset='0.0001' stop-color='#806931' />
          <stop offset='0.515625' stop-color='#FFD670' />
          <stop offset='1' stop-color='#B39448' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_43_92411'
          x1='18.75'
          y1='11.2537'
          x2='5.25'
          y2='11.2537'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#806931' />
          <stop offset='0.0001' stop-color='#806931' />
          <stop offset='0.515625' stop-color='#FFD670' />
          <stop offset='1' stop-color='#B39448' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_43_92411'
          x1='18.75'
          y1='11.2537'
          x2='5.25'
          y2='11.2537'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#806931' />
          <stop offset='0.0001' stop-color='#806931' />
          <stop offset='0.515625' stop-color='#FFD670' />
          <stop offset='1' stop-color='#B39448' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GoldIcon;
